import axios from 'axios'

import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CpCard from './_CpCard.vue'
import SearchBar from './_SearchBar.vue'

export default {
  name: 'SelfAssignableCpsModal',
  extends: BaseModal,
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
    CpCard,
    SearchBar,
  },
  data: function () {
    return {
      cps: [],
      blocker: false,
      search: {
        name: '',
        address: '',
      },
    }
  },
  created() {
    this.fetchCollectomates()
  },
  methods: {
    fetchCollectomates() {
      this.blocker = true
      axios({
        method: 'get',
        url: 'collection_points/with_locker_self_assign',
        params: {
          'q[name_cont]': this.search.name,
          'q[address_cont]': this.search.address,
        },
      })
        .then(response => {
          this.cps = response.data
        })
        .catch(error => {
          this.$errorHumanized({ error })
        })
        .finally(() => {
          this.blocker = false
        })
    },

    searchUpdateHandler: _.debounce(function (event) {
      this.search.name = event.target.value
      this.search.address = event.target.value
      this.fetchCollectomates()
    }, 300),
  },
}
